import useSWR from 'swr';

import { fetchApiClient } from '@/api/fetchers/fetchApiClient';

type SymbolInfo = {
  price: number;
  changes_percent: Record<string, number>;
  market_cap_info: any;
};

export const useSymbolInfo = (asset: string) => {
  return useSWR<SymbolInfo | null>(`/v2/info/symbol/${asset}`, fetchApiClient);
};
